export const buildTheme = (options) => {
  return options.theme
}
